import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useUser } from '../../../contexts/UserContext';
import instance from '../../AxiosInstance/AxiosInsance';
import { centralApi } from '../../AxiosInstance/CreateInstance';

const Logout = () => {
	const navigate = useNavigate();
	const { setUser } = useUser();
	const hasLoggedOut = useRef(false);

	useEffect(() => {
		const LogoutData = async () => {
			if (hasLoggedOut.current) return;
			hasLoggedOut.current = true;

			try {
				const token = localStorage.getItem('HRMS-token');

				if (!token) {
					toast('Token not found');
					navigate('/');
					return;
				}

				await centralApi.get(`/userService/user/logout`);

				localStorage.removeItem('HRMS-token');
				localStorage.removeItem('HRMS-data');
				localStorage.removeItem('facit_darkModeStatus');

				setUser({ fName: '', lName: '' });
				toast.dismiss();
				toast.success('Logout successfully', {
					closeOnClick: true,
				});
				navigate('/');
			} catch (error) {
				// console.log('error', error);
			}
		};

		LogoutData();
	}, [navigate, setUser]);

	return <div />;
};

export default Logout;
